var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#3B8BEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4062 6.21875C10.4062 5.7207 10.6699 5.28125 11.1094 5.01758C11.5195 4.75391 12.0762 4.75391 12.5156 5.01758C12.9258 5.28125 13.2188 5.7207 13.2188 6.21875C13.2188 6.74609 12.9258 7.18555 12.5156 7.44922C12.0762 7.71289 11.5195 7.71289 11.1094 7.44922C10.6699 7.18555 10.4062 6.74609 10.4062 6.21875ZM9 10.4375C9 9.93945 9.41016 9.5 9.9375 9.5H11.8125C12.3105 9.5 12.75 9.93945 12.75 10.4375V17H13.6875C14.1855 17 14.625 17.4395 14.625 17.9375C14.625 18.4648 14.1855 18.875 13.6875 18.875H9.9375C9.41016 18.875 9 18.4648 9 17.9375C9 17.4395 9.41016 17 9.9375 17H10.875V11.375H9.9375C9.41016 11.375 9 10.9648 9 10.4375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconI);
export default __webpack_public_path__ + "static/media/icon_i.98efcac0fe205769cd07fe1f174f158d.svg";
export { ForwardRef as ReactComponent };